/* eslint-disable spaced-comment */
/* eslint-disable comma-dangle */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable nonblock-statement-body-position */
/* eslint-disable curly */
/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable quotes */
import React, { useMemo, useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import { MantineReactTable } from "mantine-react-table";
import { Tabs, Button } from "@mantine/core";
import { connect, useSelector } from "react-redux";
import {
    FiBriefcase,
    FiMapPin,
    FiUser,
    FiDatabase,
    FiLayers,
    FiClock,
    FiChevronDown,
    FiChevronUp,
    FiDownload,
} from "react-icons/fi";
import PageTitle from "../../shared/PageTitle";
import { getData } from "../../../services/fetch-service";
import { normalizeStatus, statusMeta } from "./arbk/status";
import TimelineChart from "./TimelineChart";
import DokumentiModal from "./arbk/DokumentiModal";

const CollapsibleTimeline = ({ label, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <div style={{ marginTop: 12, minWidth: 0, maxWidth: "100%" }}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "6px 14px",
                    background: "#e8eef8",
                    border: "none",
                    borderRadius: 999,
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: 13,
                    color: "#1c4fb8",
                    transition: "background 0.15s",
                }}
            >
                <FiClock size={13} />
                {label}
                {open ? <FiChevronUp size={13} /> : <FiChevronDown size={13} />}
            </button>
            {open && (
                <div
                    style={{
                        marginTop: 10,
                        background: "#f8faff",
                        borderRadius: 12,
                        border: "1px solid #e2e8f7",
                        padding: "16px 16px 8px",
                        minWidth: 0,
                        maxWidth: "100%",
                        overflow: "hidden",
                        boxSizing: "border-box",
                    }}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

const TURNSTILE_SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
const isTurnstileDisabled = true; //process.env.REACT_APP_DISABLE_TURNSTILE === "true";
const isTurnstileEnabled = !isTurnstileDisabled && Boolean((process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim());

const TableDetails = (props) => {
    const { locale } = props;
    const [TableDetails, setTableDetails] = useState([]);
    const [pronaret, setPronaret] = useState([]);
    const [pronaretHistoria, setPronaretHistoria] = useState([]);
    const [bordi, setBordi] = useState([]);
    const [bordiHistoria, setBordiHistoria] = useState([]);
    const [perfaqesuesit, setPerfaqesuesit] = useState([]);
    const [perfaqesuesitHistoria, setPerfaqesuesitHistoria] = useState([]);
    const [kapitaliHistoria, setKapitaliHistoria] = useState([]);
    const [emriHistoria, setEmriHistoria] = useState([]);
    const [adresaHistoria, setAdresaHistoria] = useState([]);
    const [nrpuntoreveHistoria, setNrpuntoreveHistoria] = useState([]);
    const [aktivitetet, setAktivitetet] = useState([]);
    const [njesite, setNjesite] = useState([]);
    const [dokumentet, setDokumentet] = useState([]);
    const [dokumentiAktiv, setDokumentiAktiv] = useState(null);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [detailsLoading, setDetailsLoading] = useState(true);
    const paramsId = useSelector((state) => state.tableSearch.tableDetailsID);
    const turnstileContainerRef = useRef(null);
    const turnstileWidgetIdRef = useRef(null);

    useEffect(() => {
        const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
        const container = turnstileContainerRef.current;
        if (!isTurnstileEnabled || !siteKey || !container || !paramsId) return function noop() {};
        if (turnstileWidgetIdRef.current !== null && window.turnstile) {
            window.turnstile.remove(turnstileWidgetIdRef.current);
            turnstileWidgetIdRef.current = null;
        }
        setTurnstileToken("");
        const doRender = function doRenderFn() {
            if (window.turnstile && turnstileContainerRef.current && turnstileWidgetIdRef.current === null) {
                turnstileWidgetIdRef.current = window.turnstile.render(turnstileContainerRef.current, {
                    sitekey: siteKey,
                    theme: "light",
                    size: "normal",
                    appearance: "interaction-only",
                    callback: function onTurnstileToken(token) {
                        setTurnstileToken(token);
                    },
                });
            }
        };
        if (window.turnstile) {
            doRender();
        } else {
            const script = document.createElement("script");
            script.src = TURNSTILE_SCRIPT_URL;
            script.async = true;
            script.defer = true;
            script.onload = doRender;
            document.head.appendChild(script);
        }
        return function cleanup() {
            if (window.turnstile && turnstileWidgetIdRef.current !== null) {
                window.turnstile.remove(turnstileWidgetIdRef.current);
                turnstileWidgetIdRef.current = null;
            }
        };
    }, [paramsId]);

    useEffect(() => {
        if (!paramsId) return;
        if (isTurnstileEnabled && !turnstileToken) return;
        setDetailsLoading(true);
        const tokenQuery = isTurnstileEnabled ? `&token=${turnstileToken}` : "";
        getData(`Services/TeDhenatBiznesit?nRegjistriId=${paramsId}&Gjuha=${locale}${tokenQuery}`)
            .then((response) => {
                const d = response.data[0];
                setTableDetails(d.teDhenatBiznesit);
                setPronaret(d.pronaret);
                setPronaretHistoria(d.pronaretHistoria || []);
                setBordi(d.bordi);
                setBordiHistoria(d.bordiHistoria || []);
                setPerfaqesuesit(d.perfaqesuesit);
                setPerfaqesuesitHistoria(d.perfaqesuesitHistoria || []);
                setKapitaliHistoria(d.kapitaliHistoria || []);
                setEmriHistoria(d.emriHistoria || []);
                setAdresaHistoria(d.adresaHistoria || []);
                setNrpuntoreveHistoria(d.nrpuntoreveHistoria || []);
                setAktivitetet(d.aktivitetet);
                setNjesite(d.njesite);
                setDokumentet(d.Dokumentet || d.dokumentet || []);
            })
            .catch(() => {
                setTableDetails([]);
            })
            .finally(() => {
                setDetailsLoading(false);
            });
    }, [turnstileToken, paramsId, locale]);

    let headerName;
    let headerSurname;
    let headerPosition;
    let headerPosition2;
    let headerCapitalEuro;
    let headerCapitalPercentage;
    let headerUnitNr;
    let headerUnitName;
    let headerCode;
    let headerPlace;
    let headerDescription;
    let headerType;
    let headerNameBusiness;
    let headerNameTrade;
    let headerTypeBusiness;
    let headerNrUnique;
    let headerNrBusiness;
    let headerNrEmployees;
    let headerDataRegistration;
    let headerMuniciplaity;
    let headerAdress;
    let headerPhone;
    let headerMail;
    let headerCapital;
    let headerStatusARBK;
    let headerAuthRepresentative;
    let headerOwnerShareholders;
    let headerOwnerShareholders2;
    let headerUnits;
    let headerActivity;
    let headerNrFiscal;
    let headerBordi;
    let headerOwnerNui;
    let headerOwnerAddress;
    let headerOwnerLabel;
    let labelOwnerPhysical;
    let labelOwnerLegal;
    let labelTabARBK;
    let labelTabExtra;
    let labelHistory;
    let labelTabExtraEmpty;
    let labelBusinessHistory;
    let labelRegistration;
    let labelClosure;
    let labelBiznesi;
    let headerShteti;
    let labelDateFrom;
    let labelDateTo;
    let labelPeriudha;
    let labelVazhdon;
    let labelDate;
    let headerDocuments;
    let headerDocNr;
    let headerDocName;
    let headerDocAction;
    let labelShkarko;

    if (locale === "sq") {
        headerName = "Emri";
        headerSurname = "Mbiemri";
        headerPosition = "Pozita në biznes";
        headerPosition2 = "Pozita";
        headerCapitalEuro = "Kapitali në €";
        headerCapitalPercentage = "Kapitali në %";
        headerUnitNr = "Numri i Njësisë";
        headerUnitName = "Emri i Njësisë";
        headerCode = "Kodi";
        headerPlace = "Vendi";
        headerDescription = "Përshkrimi";
        headerType = "Tipi";
        headerNameBusiness = "Emri i biznesit";
        headerNameTrade = "Emri tregtar";
        headerTypeBusiness = "Lloji biznesit";
        headerNrUnique = "Numri unik identifikues";
        headerNrBusiness = "Numri i biznesit";
        headerNrEmployees = "Numri punëtorëve";
        headerDataRegistration = "Data e regjistrimit";
        headerMuniciplaity = "Komuna";
        headerAdress = "Adresa";
        headerPhone = "Telefoni";
        headerMail = "E-mail";
        headerCapital = "Kapitali";
        headerStatusARBK = "Statusi në ARBK";
        headerAuthRepresentative = "Përfaqësuesi i autorizuar";
        headerOwnerShareholders = "Pronar/ Aksionarë";
        headerOwnerShareholders2 = "Aksionar i privilegjuar";
        headerUnits = "Njësitë";
        headerActivity = "Aktivitet/et";
        headerNrFiscal = "Numri Fiskal";
        headerBordi = "Bordi";
        headerOwnerNui = "NUI";
        headerOwnerAddress = "Adresa";
        headerOwnerLabel = "Pronar/ Aksionar";
        labelOwnerPhysical = "Pronar Fizik";
        labelOwnerLegal = "Pronar Juridik";
        labelTabARBK = "ARBK";
        labelTabExtra = "Të dhënat shtese";
        labelHistory = "Historiku";
        labelTabExtraEmpty = "Të dhënat nga ATK nuk janë të disponueshme.";
        labelBusinessHistory = "Historiku i biznesit";
        labelRegistration = "Regjistrimi";
        labelClosure = "Shuarja e biznesit";
        labelBiznesi = "Biznesi";
        headerShteti = "Shteti";
        labelDateFrom = "Data prej";
        labelDateTo = "Data deri";
        labelPeriudha = "Periudha";
        labelVazhdon = "Vazhdon";
        labelDate = "Data";
        headerDocuments = "Dokumentet";
        headerDocNr = "Nr. rendor";
        headerDocName = "Emri i dokumentit";
        headerDocAction = "Veprimi";
        labelShkarko = "Shkarko";
    } else if (locale === "en") {
        headerName = "Name";
        headerSurname = "LastName";
        headerPosition = "Position in business";
        headerPosition2 = "Position";
        headerCapitalEuro = "Capital in €";
        headerCapitalPercentage = "Capital in %";
        headerUnitNr = "Unit Number";
        headerUnitName = "Name";
        headerCode = "Code";
        headerPlace = "Place";
        headerDescription = "Description";
        headerType = "Type";
        headerNameBusiness = "Business Name";
        headerNameTrade = "Trade Name";
        headerTypeBusiness = "Type of business";
        headerNrUnique = "Unique identification number";
        headerNrBusiness = "Business number";
        headerNrEmployees = "Number of employees";
        headerDataRegistration = "Registration date";
        headerMuniciplaity = "Municipality";
        headerAdress = "Address";
        headerPhone = "Phone number";
        headerMail = "E-mail";
        headerCapital = "Capital";
        headerStatusARBK = "Status in KBRA";
        headerAuthRepresentative = "Authorised persons";
        headerOwnerShareholders = "Owner/ Shareholders";
        headerOwnerShareholders2 = "Privileged Shareholder";
        headerUnits = "Units";
        headerActivity = "Activity/ies";
        headerNrFiscal = "Fiscal number";
        headerBordi = "Board";
        headerOwnerNui = "NUI";
        headerOwnerAddress = "Address";
        headerOwnerLabel = "Owner/ Shareholder";
        labelOwnerPhysical = "Individual Owner";
        labelOwnerLegal = "Legal Owner";
        labelTabARBK = "KBRA";
        labelTabExtra = "Additional data";
        labelHistory = "History";
        labelTabExtraEmpty = "TAK data is not available.";
        labelBusinessHistory = "Business history";
        labelRegistration = "Registration";
        labelClosure = "Business closure";
        labelBiznesi = "Business";
        headerShteti = "Country";
        labelDateFrom = "Date from";
        labelDateTo = "Date to";
        labelPeriudha = "Period";
        labelVazhdon = "Ongoing";
        labelDate = "Date";
        headerDocuments = "Documents";
        headerDocNr = "No.";
        headerDocName = "Document name";
        headerDocAction = "Action";
        labelShkarko = "Download";
    } else if (locale === "sr") {
        headerName = "Ime";
        headerSurname = "Prezime";
        headerPosition = "Položaj u poslu";
        headerPosition2 = "Položaj";
        headerCapitalEuro = "Kapital u €";
        headerCapitalPercentage = "Kapital u %";
        headerUnitNr = "Br. Broj jedinice";
        headerUnitName = "Ime";
        headerCode = "Kod";
        headerPlace = "Zemlja";
        headerDescription = "Opis";
        headerType = "Tip";
        headerNameBusiness = "Naziv biznisa";
        headerNameTrade = "Trgovačko ime";
        headerTypeBusiness = "Vrsta biznisa";
        headerNrUnique = "Jedinstveni identifikacioni broj";
        headerNrBusiness = "Broj biznisa";
        headerNrEmployees = "Broj radnika";
        headerDataRegistration = "Datum registracije";
        headerMuniciplaity = "Opština";
        headerAdress = "Adresa";
        headerPhone = "Telefon";
        headerMail = "E-mail";
        headerCapital = "Kapital";
        headerStatusARBK = "Status u KARB-u";
        headerAuthRepresentative = "Ovlašćena Lica";
        headerOwnerShareholders = "Vlasnik/ Akcionari";
        headerOwnerShareholders2 = "Privilegovani akcionar";
        headerUnits = "Jedinica";
        headerActivity = "Aktivnost/i";
        headerNrFiscal = "Fiskalni broj";
        headerBordi = "Odbor";
        headerOwnerNui = "JIB";
        headerOwnerAddress = "Adresa";
        headerOwnerLabel = "Vlasnik/ Akcionar";
        labelOwnerPhysical = "Fizički vlasnik";
        labelOwnerLegal = "Pravni vlasnik";
        labelTabARBK = "KARB";
        labelTabExtra = "Dodatni podaci";
        labelHistory = "Istorija";
        labelTabExtraEmpty = "Podaci iz PAK nisu dostupni.";
        labelBusinessHistory = "Istorija biznisa";
        labelRegistration = "Registracija";
        labelClosure = "Zatvaranje biznisa";
        labelBiznesi = "Biznis";
        headerShteti = "Država";
        labelDateFrom = "Datum od";
        labelDateTo = "Datum do";
        labelPeriudha = "Period";
        labelVazhdon = "U toku";
        labelDate = "Datum";
        headerDocuments = "Dokumenti";
        headerDocNr = "Redni br.";
        headerDocName = "Naziv dokumenta";
        headerDocAction = "Radnja";
        labelShkarko = "Preuzmi";
    }

    const tipLabels = {
        tipName: headerName,
        tipSurname: headerSurname,
        tipNui: headerOwnerNui,
        tipCapital: headerCapitalEuro,
        tipCapitalPct: headerCapitalPercentage,
        tipAddress: headerAdress,
        tipPosition: headerPosition2,
        tipDate: headerDataRegistration,
        tipDateFrom: labelDateFrom,
        tipDateTo: labelDateTo,
        tipPeriudha: labelPeriudha,
        tipVazhdon: labelVazhdon,
        tipData: labelDate,
    };

    const isLegalOwner = (ownerItem) => ownerItem?.Fizik === false || ownerItem?.fizik === false;

    const getOwnerBadgeLabel = (ownerItem) => (isLegalOwner(ownerItem) ? labelOwnerLegal : labelOwnerPhysical);

    const getOwnerNui = (ownerItem) => String(ownerItem?.NUI ?? ownerItem?.nui ?? "").trim();

    const getFlagPath = (countryCode) => {
        const normalizedCode = (countryCode || "xx").toString().trim().toLowerCase();
        return `/images/flags/${normalizedCode}.svg`;
    };

    const stripCountryCodeFromName = (countryName, countryCode) => {
        let name = (countryName || "").trim();
        if (!name) return "";
        const code = (countryCode || "").trim();
        if (code) {
            const escapedCode = code.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            name = name.replace(new RegExp(`,\\s*${escapedCode}\\s*$`, "i"), "").trim();
        }
        return name.replace(/,\s*[A-Za-z]{2}\s*$/, "").trim();
    };

    const getOwnerCountry = (ownerItem) => {
        if (!ownerItem || typeof ownerItem !== "object") return "";
        let countryName = "";
        if (locale === "en")
            countryName =
                ownerItem.ShtetiEN ||
                ownerItem.shtetiEN ||
                ownerItem.ShtetiSQ ||
                ownerItem.shtetiSQ ||
                ownerItem.ShtetiSR ||
                // eslint-disable-next-line operator-linebreak
                ownerItem.shtetiSR ||
                "";
        else if (locale === "sr")
            countryName =
                ownerItem.ShtetiSR ||
                ownerItem.shtetiSR ||
                ownerItem.ShtetiSQ ||
                ownerItem.shtetiSQ ||
                ownerItem.ShtetiEN ||
                ownerItem.shtetiEN ||
                "";
        else
            countryName =
                ownerItem.ShtetiSQ ||
                ownerItem.shtetiSQ ||
                ownerItem.ShtetiEN ||
                ownerItem.shtetiEN ||
                ownerItem.ShtetiSR ||
                ownerItem.shtetiSR ||
                "";
        return stripCountryCodeFromName(countryName, ownerItem.CodeShteti || ownerItem.codeShteti);
    };

    const statusKey = normalizeStatus(TableDetails.StatusiARBK);
    const statusDisplay = statusKey === "unknown" ? TableDetails.StatusiARBK : statusMeta(statusKey, locale).label;

    const pronaretDisplay = useMemo(
        () =>
            Array.isArray(pronaret)
                ? pronaret.map((item) => ({
                      ...item,
                      ShtetiDisplay: getOwnerCountry(item),
                      AdresaDisplay: (item?.Adresa || "").trim(),
                  }))
                : [],
        [pronaret, locale]
    );

    const perfaqesuesitDisplay = useMemo(
        () =>
            Array.isArray(perfaqesuesit)
                ? perfaqesuesit.map((item) => ({ ...item, ShtetiDisplay: getOwnerCountry(item) }))
                : [],
        [perfaqesuesit, locale]
    );

    const bordiDisplay = useMemo(
        () => (Array.isArray(bordi) ? bordi.map((item) => ({ ...item, ShtetiDisplay: getOwnerCountry(item) })) : []),
        [bordi, locale]
    );

    const renderCountryFlagCell = ({ row, cell }) => {
        const item = row.original || {};
        const countryCode = item?.CodeShteti || "xx";
        const countryName = cell.getValue() || "";
        if (!countryName && !item?.CodeShteti) {
            return <span style={{ color: "#9aa5b1" }}>—</span>;
        }
        return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <img
                    src={getFlagPath(countryCode)}
                    alt={item?.CodeShteti || "flag"}
                    width={24}
                    height={18}
                    onError={(event) => {
                        if (event.currentTarget.src.indexOf("/images/flags/xx.svg") !== -1) return;
                        event.currentTarget.src = "/images/flags/xx.svg";
                    }}
                    style={{ flexShrink: 0, objectFit: "cover", borderRadius: 2, border: "1px solid #e5e7eb" }}
                />
                <span>{countryName}</span>
            </div>
        );
    };

    const perfaqesuesitColumns = useMemo(
        () => [
            { accessorKey: "Emri", header: [headerName] },
            { accessorKey: "Mbiemri", header: [headerSurname] },
            { accessorKey: "Pozita", header: [headerPosition] },
            { accessorKey: "ShtetiDisplay", header: [headerShteti], Cell: renderCountryFlagCell },
        ],
        []
    );

    const pronaretOwnerColumns = useMemo(
        () => [
            {
                accessorKey: "Pronari",
                header: [headerOwnerLabel],
                Cell: ({ row, cell }) => {
                    const ownerItem = row.original || {};
                    const ownerBadge = getOwnerBadgeLabel(ownerItem);
                    const isBusiness = isLegalOwner(ownerItem);
                    const ownerNui = getOwnerNui(ownerItem);
                    const Icon = isBusiness ? FiBriefcase : FiUser;
                    return (
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div
                                style={{
                                    width: 44,
                                    height: 44,
                                    minWidth: 44,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: isBusiness ? "#e8f5ee" : "#e8eef8",
                                    color: isBusiness ? "#14954f" : "#1c4fb8",
                                }}
                            >
                                <Icon size={20} />
                            </div>
                            <div style={{ display: "grid", gap: 4 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                    <strong>{cell.getValue() || ""}</strong>
                                </div>
                                <span
                                    style={{
                                        width: "fit-content",
                                        padding: "2px 10px",
                                        borderRadius: 999,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: isBusiness ? "#14954f" : "#1c4fb8",
                                        backgroundColor: isBusiness ? "#e8f5ee" : "#e8eef8",
                                    }}
                                >
                                    {ownerBadge}
                                </span>
                                {isBusiness ? (
                                    <span style={{ color: "#606e85" }}>{`${headerOwnerNui}: ${ownerNui}`}</span>
                                ) : null}
                            </div>
                        </div>
                    );
                },
            },
            { accessorKey: "Kapitali", header: [headerCapitalEuro] },
            {
                accessorKey: "AdresaDisplay",
                header: [headerOwnerAddress],
                Cell: ({ row, cell }) => {
                    const ownerItem = row.original || {};
                    const countryCode = ownerItem?.CodeShteti || "xx";
                    const addressValue = cell.getValue() || "";
                    return (
                        <div style={{ display: "grid", gap: 8 }}>
                            {addressValue ? (
                                <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                                    <span
                                        style={{
                                            flexShrink: 0,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 18,
                                            height: 18,
                                            minWidth: 18,
                                            marginTop: 2,
                                            color: "#1c4fb8",
                                        }}
                                    >
                                        <FiMapPin size={18} />
                                    </span>
                                    <span>{addressValue}</span>
                                </div>
                            ) : null}
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <img
                                    src={getFlagPath(countryCode)}
                                    alt={ownerItem?.CodeShteti || "flag"}
                                    width={24}
                                    height={18}
                                    onError={(event) => {
                                        if (event.currentTarget.src.indexOf("/images/flags/xx.svg") !== -1) return;
                                        event.currentTarget.src = "/images/flags/xx.svg";
                                    }}
                                    style={{
                                        flexShrink: 0,
                                        objectFit: "cover",
                                        borderRadius: 2,
                                        border: "1px solid #e5e7eb",
                                    }}
                                />
                                <span>{ownerItem?.ShtetiDisplay || ""}</span>
                            </div>
                        </div>
                    );
                },
            },
            { accessorKey: "KapitaliPerqindje", header: [headerCapitalPercentage] },
        ],
        [
            headerOwnerLabel,
            headerOwnerNui,
            headerOwnerAddress,
            headerCapitalEuro,
            headerCapitalPercentage,
            labelOwnerPhysical,
            labelOwnerLegal,
        ]
    );

    const bordiColumns = useMemo(
        () => [
            { accessorKey: "Emri", header: [headerName] },
            { accessorKey: "Mbiemri", header: [headerSurname] },
            { accessorKey: "Pozita", header: [headerPosition2] },
            { accessorKey: "ShtetiDisplay", header: [headerShteti], Cell: renderCountryFlagCell },
        ],
        []
    );

    const njesiteColumns = useMemo(
        () => [
            { accessorKey: "Numri", header: [headerUnitNr] },
            { accessorKey: "Emri", header: [headerUnitName] },
            { accessorKey: "NaceKodi", header: [headerCode] },
            { accessorKey: "Vendi", header: [headerPlace] },
        ],
        []
    );

    const nuiBiznesit = String(TableDetails?.NUI ?? TableDetails?.nui ?? "").trim();

    const dokumentetDisplay = useMemo(
        () =>
            (Array.isArray(dokumentet) ? dokumentet : []).map((item, index) => ({
                NrRendor: index + 1,
                DokumentiID: item?.nRegjistriDokumentiID || item?.NRegjistriDokumentiID || "",
                EmriDokumentit: item?.EmriDokumentit || item?.emriDokumentit || "",
                ShikoUrl: item?.ShikoUrl || item?.shikoUrl || "",
            })),
        [dokumentet]
    );

    const dokumentetColumns = useMemo(
        () => [
            { accessorKey: "NrRendor", header: [headerDocNr], size: 60 },
            { accessorKey: "EmriDokumentit", header: [headerDocName], size: 500 },
            {
                accessorKey: "ShikoUrl",
                header: [headerDocAction],
                enableSorting: false,
                Cell: ({ row }) => {
                    const item = row.original || {};
                    if (!item.ShikoUrl && !item.DokumentiID) {
                        return <span style={{ color: "#9aa5b1" }}>—</span>;
                    }
                    return (
                        <Button
                            size="xs"
                            variant="light"
                            leftIcon={<FiDownload size={14} />}
                            onClick={() => setDokumentiAktiv({
                                id: item.DokumentiID,
                                emri: item.EmriDokumentit,
                                nui: nuiBiznesit,
                            })}
                        >
                            {labelShkarko}
                        </Button>
                    );
                },
            },
        ],
        [headerDocNr, headerDocName, headerDocAction, labelShkarko, nuiBiznesit]
    );

    const aktivitetetColumns = useMemo(
        () => [
            { accessorKey: "KodiNace", header: [headerCode], size: 50 },
            { accessorKey: "Pershkrimi", header: [headerDescription], size: 500 },
            { accessorKey: "LlojiAktivitetit", header: [headerType] },
        ],
        []
    );

    const hasData = (arr) => Array.isArray(arr) && arr.length > 0;

    const hasRenderableHistory = (arr, textKey = null) =>
        Array.isArray(arr) &&
        arr.some((h) => {
            if (!h.dtPrej) return false;
            const d = dayjs(h.dtPrej);
            if (!d.isValid()) return false;
            if (textKey) return !!(h[textKey] || "").trim();
            return !!(h.emri || h.mbiemri || h.Ndryshimet || h.ndryshimet || "").trim();
        });

    const pronaretRegular = useMemo(
        () => (Array.isArray(pronaretDisplay) ? pronaretDisplay.filter((item) => item.LlojiAksionaritID === 1) : []),
        [pronaretDisplay]
    );
    const pronaretPrivileged = useMemo(
        () => (Array.isArray(pronaretDisplay) ? pronaretDisplay.filter((item) => item.LlojiAksionaritID !== 1) : []),
        [pronaretDisplay]
    );

    const mantineTableProps = {
        enableGlobalFilter: false,
        enableGlobalFilterModes: false,
        enableFilterMatchHighlighting: false,
        enableGlobalFilterRankedResults: false,
        enableBottomToolbar: false,
        search: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enablePagination: false,
        state: { isLoading: false },
    };

    const businessCustomEvents = useMemo(() => {
        const events = [];
        const isRealDate = (raw) => !!raw && dayjs(raw).isValid() && dayjs(raw).year() > 1900;
        const seen = new Set();

        const pushRegistration = (raw) => {
            events.push({
                date: dayjs(raw).toISOString(),
                text: labelRegistration,
                cat: "biznes",
                priority: -1,
                singleDate: true,
                tip: {
                    title: labelRegistration,
                    badge: labelBiznesi,
                    rows: [
                        TableDetails.EmriBiznesit && { label: headerNameBusiness, value: TableDetails.EmriBiznesit },
                        TableDetails.NUI && { label: headerNrUnique, value: TableDetails.NUI },
                        TableDetails.NumriBiznesit && { label: headerNrBusiness, value: TableDetails.NumriBiznesit },
                    ].filter(Boolean),
                },
            });
        };

        const pushClosure = (raw) => {
            events.push({
                date: dayjs(raw).toISOString(),
                text: labelClosure,
                cat: "biznes",
                singleDate: true,
                tip: {
                    title: labelClosure,
                    badge: labelBiznesi,
                    rows: [
                        TableDetails.EmriBiznesit && { label: headerNameBusiness, value: TableDetails.EmriBiznesit },
                    ].filter(Boolean),
                },
            });
        };

        const addEvent = (raw, kind) => {
            if (!isRealDate(raw)) return;
            const key = `${kind}-${dayjs(raw).valueOf()}`;
            if (seen.has(key)) return;
            seen.add(key);
            if (kind === "reg") pushRegistration(raw);
            else pushClosure(raw);
        };

        addEvent(TableDetails?.DataRegjistrimit_Status10, "reg");
        addEvent(TableDetails?.DataShuarjes_Status10, "clo");
        addEvent(TableDetails?.DataRegjistrimit, "reg");
        addEvent(TableDetails?.DataShuarjesBiznesit, "clo");

        return events;
    }, [
        TableDetails,
        labelRegistration,
        labelClosure,
        labelBiznesi,
        headerNameBusiness,
        headerNrUnique,
        headerNrBusiness,
    ]);

    const hasBusinessHistory =
        businessCustomEvents.length > 0 ||
        hasData(pronaretHistoria) ||
        hasData(perfaqesuesitHistoria) ||
        hasData(bordiHistoria) ||
        hasData(kapitaliHistoria) ||
        hasData(emriHistoria) ||
        hasData(adresaHistoria) ||
        hasData(nrpuntoreveHistoria);

    const hasTopBusinessHistory =
        businessCustomEvents.length > 0 ||
        hasData(kapitaliHistoria) ||
        hasData(emriHistoria) ||
        hasData(adresaHistoria) ||
        hasData(nrpuntoreveHistoria);

    const showContent = TableDetails && TableDetails.EmriBiznesit && !detailsLoading;

    return (
        <div className="arbk-details">
            {isTurnstileEnabled && (
                <div
                    ref={turnstileContainerRef}
                    style={{ position: "absolute", left: -9999, overflow: "hidden" }}
                    aria-hidden="true"
                />
            )}
            {!showContent && (
                <div className="table-details" style={{ padding: "2rem", textAlign: "center" }}>
                    {!paramsId ? (
                        <p>Nuk eshte zgjedhur biznesi.</p>
                    ) : isTurnstileEnabled && !turnstileToken ? (
                        <p>Duke verifikuar...</p>
                    ) : (
                        <p>Duke ngarkuar te dhenat...</p>
                    )}
                </div>
            )}
            {showContent && (
                <React.Fragment>
                    <PageTitle header={TableDetails.EmriBiznesit} />
                    <Tabs
                        defaultValue="arbk"
                        mt="md"
                        styles={() => ({
                            root: {},
                            tabsList: {
                                display: "flex",
                                width: "100%",
                                borderBottom: "2px solid #e5e9f5",
                                gap: 0,
                                marginBottom: 0,
                                background: "transparent",
                            },
                            tab: {
                                flex: 1,
                                fontWeight: 600,
                                fontSize: 14,
                                padding: "13px 20px",
                                border: "none",
                                borderBottom: "2px solid transparent",
                                marginBottom: -2,
                                borderRadius: 0,
                                color: "#6b7280",
                                background: "transparent",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 8,
                                transition: "color 0.15s ease, border-color 0.15s ease, background 0.15s ease",
                                "&:hover": {
                                    color: "#1c4fb8",
                                    background: "#f1f4fb",
                                },
                                "&[data-active]": {
                                    color: "#1c4fb8",
                                    borderBottomColor: "#1c4fb8",
                                    background: "#f7f9ff",
                                },
                            },
                            panel: {
                                paddingTop: 20,
                            },
                        })}
                    >
                        <Tabs.List>
                            <Tabs.Tab value="arbk" icon={<FiDatabase size={15} />}>
                                {labelTabARBK}
                            </Tabs.Tab>
                            <Tabs.Tab value="extra" icon={<FiLayers size={15} />}>
                                {labelTabExtra}
                            </Tabs.Tab>
                        </Tabs.List>

                        <Tabs.Panel value="arbk" pt="md">
                            <div className="table-details">
                                <table>
                                    <tr>
                                        <th>{headerNameBusiness}</th>
                                        <td>{TableDetails.EmriBiznesit}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerNameTrade}</th>
                                        <td>{TableDetails.EmriTregtar}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerTypeBusiness}</th>
                                        <td>{TableDetails.LlojiBiznesit}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerNrUnique}</th>
                                        <td>{TableDetails.NUI}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerNrBusiness}</th>
                                        <td>{TableDetails.NumriBiznesit}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerNrFiscal}</th>
                                        <td>{TableDetails.NumriFiskal}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerNrEmployees}</th>
                                        <td>{TableDetails.NumriPunetoreve}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerDataRegistration}</th>
                                        <td>
                                            {TableDetails.DataRegjistrimit &&
                                            dayjs(TableDetails.DataRegjistrimit).isValid()
                                                ? dayjs(TableDetails.DataRegjistrimit).format("DD/MM/YYYY")
                                                : "—"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{headerMuniciplaity}</th>
                                        <td>{TableDetails.Komuna}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerAdress}</th>
                                        <td>{TableDetails.Adresa}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerPhone}</th>
                                        <td>{TableDetails.Telefoni}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerMail}</th>
                                        <td>{TableDetails.Email}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerCapital}</th>
                                        <td>{TableDetails.Kapitali}</td>
                                    </tr>
                                    <tr>
                                        <th>{headerStatusARBK}</th>
                                        <td>{statusDisplay}</td>
                                    </tr>
                                </table>
                            </div>

                            <div className="TableSearch-section">
                                {hasTopBusinessHistory && (
                                    <div className="content-details">
                                        <CollapsibleTimeline label={labelBusinessHistory}>
                                            <TimelineChart
                                                kapitaliHistoria={kapitaliHistoria}
                                                emriHistoria={emriHistoria}
                                                adresaHistoria={adresaHistoria}
                                                nrpuntoreveHistoria={nrpuntoreveHistoria}
                                                customEvents={businessCustomEvents}
                                                locale={locale}
                                                labels={{
                                                    ...tipLabels,
                                                    kapital: headerCapital,
                                                    biznes: labelBiznesi,
                                                    emri: headerNameBusiness,
                                                    adresa: headerAdress,
                                                    nrpuntoreve: headerNrEmployees,
                                                }}
                                            />
                                        </CollapsibleTimeline>
                                    </div>
                                )}

                                {hasData(perfaqesuesit) && (
                                    <div className="content-details">
                                        <h4>{headerAuthRepresentative}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={perfaqesuesitColumns}
                                                data={perfaqesuesitDisplay}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                        {hasRenderableHistory(perfaqesuesitHistoria) && (
                                            <CollapsibleTimeline label={labelHistory}>
                                                <TimelineChart
                                                    perfaqesuesitHistoria={perfaqesuesitHistoria}
                                                    locale={locale}
                                                    labels={{ ...tipLabels, perfaqesuesit: headerAuthRepresentative }}
                                                />
                                            </CollapsibleTimeline>
                                        )}
                                    </div>
                                )}

                                {hasData(pronaretRegular) && (
                                    <div className="content-details">
                                        <h4>{headerOwnerShareholders}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={pronaretOwnerColumns}
                                                data={pronaretRegular}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                        {hasRenderableHistory(
                                            pronaretHistoria.filter((h) => h.llojiAksionaritID === 1),
                                            "pronari"
                                        ) && (
                                            <CollapsibleTimeline label={labelHistory}>
                                                <TimelineChart
                                                    pronaretHistoria={pronaretHistoria.filter(
                                                        (h) => h.llojiAksionaritID === 1
                                                    )}
                                                    locale={locale}
                                                    labels={{ ...tipLabels, pronaret: headerOwnerShareholders }}
                                                />
                                            </CollapsibleTimeline>
                                        )}
                                    </div>
                                )}

                                {hasData(pronaretPrivileged) && (
                                    <div className="content-details">
                                        <h4>{headerOwnerShareholders2}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={pronaretOwnerColumns}
                                                data={pronaretPrivileged}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                        {hasRenderableHistory(
                                            pronaretHistoria.filter((h) => h.llojiAksionaritID !== 1),
                                            "pronari"
                                        ) && (
                                            <CollapsibleTimeline label={labelHistory}>
                                                <TimelineChart
                                                    pronaretHistoria={pronaretHistoria.filter(
                                                        (h) => h.llojiAksionaritID !== 1
                                                    )}
                                                    locale={locale}
                                                    labels={{ ...tipLabels, pronaret: headerOwnerShareholders2 }}
                                                />
                                            </CollapsibleTimeline>
                                        )}
                                    </div>
                                )}

                                {hasData(bordi) && (
                                    <div className="content-details">
                                        <h4>{headerBordi}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={bordiColumns}
                                                data={bordiDisplay}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                        {hasRenderableHistory(bordiHistoria) && (
                                            <CollapsibleTimeline label={labelHistory}>
                                                <TimelineChart
                                                    bordiHistoria={bordiHistoria}
                                                    locale={locale}
                                                    labels={{ ...tipLabels, bordi: headerBordi }}
                                                />
                                            </CollapsibleTimeline>
                                        )}
                                    </div>
                                )}

                                {hasData(njesite) && (
                                    <div className="content-details">
                                        <h4>{headerUnits}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={njesiteColumns}
                                                data={njesite}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                    </div>
                                )}

                                {hasData(dokumentetDisplay) && (
                                    <div className="content-details">
                                        <h4>{headerDocuments}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={dokumentetColumns}
                                                data={dokumentetDisplay}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                    </div>
                                )}

                                {hasData(aktivitetet) && (
                                    <div className="content-details">
                                        <h4>{headerActivity}</h4>
                                        <div className="table-search" style={{ overflowX: "auto", minWidth: 0, maxWidth: "100%" }}>
                                            <MantineReactTable
                                                className="mantine-table"
                                                columns={aktivitetetColumns}
                                                data={aktivitetet}
                                                {...mantineTableProps}
                                            />
                                        </div>
                                    </div>
                                )}

                                {hasBusinessHistory && (
                                    <div className="content-details">
                                        <h4>{labelBusinessHistory}</h4>
                                        <div
                                            style={{
                                                background: "#f8faff",
                                                borderRadius: 12,
                                                border: "1px solid #e2e8f7",
                                                padding: "16px 16px 8px",
                                                minWidth: 0,
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <TimelineChart
                                                pronaretHistoria={pronaretHistoria}
                                                perfaqesuesitHistoria={perfaqesuesitHistoria}
                                                bordiHistoria={bordiHistoria}
                                                kapitaliHistoria={kapitaliHistoria}
                                                emriHistoria={emriHistoria}
                                                adresaHistoria={adresaHistoria}
                                                nrpuntoreveHistoria={nrpuntoreveHistoria}
                                                customEvents={businessCustomEvents}
                                                locale={locale}
                                                labels={{
                                                    ...tipLabels,
                                                    pronaret: headerOwnerShareholders,
                                                    perfaqesuesit: headerAuthRepresentative,
                                                    bordi: headerBordi,
                                                    kapital: headerCapital,
                                                    biznes: labelBiznesi,
                                                    emri: headerNameBusiness,
                                                    adresa: headerAdress,
                                                    nrpuntoreve: headerNrEmployees,
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                            </div>
                        </Tabs.Panel>

                        <Tabs.Panel value="extra" pt="md">
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "4rem 2rem",
                                    background: "#f8faff",
                                    borderRadius: 12,
                                    border: "1.5px dashed #c7d4f0",
                                    gap: 12,
                                }}
                            >
                                <div
                                    style={{
                                        width: 52,
                                        height: 52,
                                        borderRadius: "50%",
                                        background: "#e8eef8",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#1c4fb8",
                                    }}
                                >
                                    <FiLayers size={24} />
                                </div>
                                <p style={{ margin: 0, color: "#6b7280", fontSize: 15 }}>{labelTabExtraEmpty}</p>
                            </div>
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            )}

            <DokumentiModal
                opened={Boolean(dokumentiAktiv)}
                dokumenti={dokumentiAktiv}
                locale={locale}
                onClose={() => setDokumentiAktiv(null)}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(TableDetails);
